import { createFileRoute } from '@tanstack/react-router';
import GalleryManagement from '../../components/manager/GalleryManagement';
import ManagerPortal from '../../components/portals/ManagerPortal';

export const Route = createFileRoute('/manager/media')({
  component: ManagerMediaRoute,
});

function ManagerMediaRoute() {
  return (
    <ManagerPortal>
      <GalleryManagement />
    </ManagerPortal>
  );
}
